import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../apiConfig";
import { useNavigate } from "react-router-dom";

const PanFind = () => {   //add by jinal
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		aadhaarNo: "",
		name: "",
		dateOfBirth: "",
	});

	const [serverError, setServerError] = useState("");
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [showResultModal, setShowResultModal] = useState(false);
	const [resultDetails, setResultDetails] = useState(null);
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({ aadhaarNo: "", });

	const [editId, setEditId] = useState(null);
	// Aadhaar validation regex
	const aadhaarRegex = /^[2-9]{1}[0-9]{11}$/;

	// Load existing record if editing
	useEffect(() => {
		const id = localStorage.getItem("panFindId");
		if (id) {
			setEditId(id);
			const authToken = localStorage.getItem("authToken");
			//fetch(`https://apiv2.chakran.in/api/PanFind/GetPanFindById/${id}`, {
			fetch(`${API_BASE_URL}/PanFind/GetPanFindById/${id}`, {
				headers: { Authorization: `Bearer ${authToken}` },
			})
				.then((res) => res.json())
				.then((data) => {
					setFormData({
						aadhaarNo: data.aadhaarNo,
						name: data.name,
						dateOfBirth: data.dateOfBirth
							? new Date(data.dateOfBirth).toISOString().split("T")[0]
							: "",
					});
				})
				.catch((err) => console.error("Error loading record:", err));
		}
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;


		if (name === "aadhaarNo") {
			const digitsOnly = value.replace(/\D/g, "");
			if (digitsOnly.length > 12) return; // Prevent more than 12 digits

			let errorMsg = "";
			if (!digitsOnly) {
				errorMsg = "Aadhaar No is required.";
			} else if (digitsOnly.length < 12) {
				errorMsg = "Aadhaar No must be 12 digits.";
			} else if (!/^[2-9]{1}[0-9]{11}$/.test(digitsOnly)) {
				errorMsg = "Enter valid Aadhaar number (first digit 2-9, total 12 digits).";
			}
			setErrors((prev) => ({ ...prev, aadhaarNo: errorMsg }));
			setFormData((prev) => ({ ...prev, [name]: digitsOnly }));
			return;
		}

		setFormData((prev) => ({ ...prev, [name]: value }));
	};


	const handleStay = () => {
		setShowConfirmModal(false);
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();
		setServerError("");

		// Final validation before showing modal
		if (errors.aadhaarNo || !formData.aadhaarNo) {
			setServerError("Please enter a valid Aadhaar No.");
			return;
		}
		if (errors.name || !formData.name) {
			setServerError("Please enter a valid Name.");
			return;
		}

		setShowConfirmModal(true);
	};
	const handleConfirm = async () => {
		setShowConfirmModal(false);

		const formattedDate = new Date(formData.dateOfBirth).toLocaleDateString("en-GB");
		const panFindDto = {
			AadhaarNo: formData.aadhaarNo,
			Name: formData.name,
			DateOfBirth: formattedDate,
		};
		const authToken = localStorage.getItem("authToken");

		setLoading(true);
		try {
			const url = editId
				? `${API_BASE_URL}/PanFind/UpdatePanFind/${editId}`
				: `${API_BASE_URL}/PanFind/PanFind`;

			const method = editId ? "PUT" : "POST";

			const response = await fetch(url, {
				method,
				headers: {
					Authorization: `Bearer ${authToken}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(panFindDto),
			});

			const data = await response.json();

			if (response.ok) {
				localStorage.removeItem("panFindId");
				window.dispatchEvent(new Event("balanceUpdated"));
				
				if (editId) {
					alert("Record updated successfully!");
					navigate("/dashboard/pan-find-report");
				} else {
					setResultDetails({
						success: true,
						panNumber: data.panNumber,
						message: data.message
					});
					setShowResultModal(true);
				}
			} else {
				if (editId) {
					alert(`Error: ${data.message || "Update failed."}`);
				} else {
					setResultDetails({
						success: false,
						message: data.message || "PAN search failed."
					});
					setShowResultModal(true);
				}
			}
		} catch (err) {
			setServerError(err.message);
			if (editId) {
				alert("An error occurred while submitting data.");
			} else {
				setResultDetails({
					success: false,
					message: "An error occurred while connecting to the server."
				});
				setShowResultModal(true);
			}
		} finally {
			setLoading(false);
		}
	};
	//   try {
	//     const response = await fetch("https://apiv2.chakran.in/api/PanFind/PanFind", {
	//       method: "POST",
	//       headers: {
	//         Authorization: `Bearer ${authToken}`,
	//         "Content-Type": "application/json",
	//       },
	//       body: JSON.stringify(panFindDto),
	//     });

	//     if (response.ok) {
	//       const data = await response.json();
	//       alert(`Data saved successfully!`);
	//       window.dispatchEvent(new Event("balanceUpdated"));
	//       setFormData({ aadhaarNo: "", name: "", dateOfBirth: "" });
	//     } else {
	//       const error = await response.json();
	//       alert(`Error: ${error.message}`);
	//     }
	//   } catch (err) {
	//     setServerError(err.message);
	//     alert("An error occurred while submitting data.");
	//   }
	// };		
	return (
		<div className="kids-avenue-font">
			<form onSubmit={handleFormSubmit}>
				<div className="card card-default">
					<div className="card-body">
						<div className="row">
							<div className="form-group col-md-3">
								<label for="aadharNo">Aadhar No <span style={{ color: "red" }}>*</span></label>
								<input
									type="text"
									className="form-control"
									id="AadharNo"
									name="aadhaarNo"
									value={formData.aadhaarNo}
									onChange={handleChange}
									maxLength={12}
								/>
								{errors.aadhaarNo && <small style={{ color: "red" }}>{errors.aadhaarNo}</small>}
							</div>
							<div className="form-group col-md-3">
								<label for="AoType">Name as per Aadhar</label>
								<input
									type="text"
									className="form-control"
									id="NameAadhar"
									name="name"
									value={formData.name}
									onChange={handleChange}
								/>

							</div>
							<div className="form-group col-md-3">
								<label for="RangeCode">Date Of Birth (DOB)</label>
								<div className="input-group mb-3">
									<input
										type="date"
										className="form-control"
										name="dateOfBirth"
										value={formData.dateOfBirth}
										onChange={handleChange}
									/>
								</div>
								<p style={{ fontSize: '90%' }}>ex. 99/99/9999</p>
							</div>
						</div>
						<div className="form-footer pt-4 text-center">
							{!editId && <p>Note: Form Submission Charges Rs.45</p>}
							<button 
								type="submit" 
								className="btn btn-primary btn-pill"
								disabled={loading}
							>
								{loading ? (
									<>
										<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: "1rem", height: "1rem", marginRight: "8px" }}></span>
										Searching PAN...
									</>
								) : (
									editId ? "Update" : "Submit"
								)}
							</button>
						</div>
					</div>
				</div>

				{serverError && <div className="alert alert-danger">{serverError}</div>}
			</form>
			{showConfirmModal && (
				<div className="modal-backdrop" style={{
					position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
					background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
				}}>
					<div style={{
						background: "#fff", padding: 24, borderRadius: 10, minWidth: 320, textAlign: "center", boxShadow: "0 5px 20px rgba(0,0,0,0.2)"
					}}>
						<h5 style={{ color: "#9e6de0", fontWeight: "bold", marginBottom: 12 }}>Confirm Submission</h5>
						<p style={{ color: "#455a64" }}>Do you want to submit this PAN search request? Charges: ₹45</p>
						<div style={{ marginTop: 20 }}>
							<button className="btn btn-secondary mr-2 btn-pill" onClick={handleStay}>Stay</button>
							<button className="btn btn-primary btn-pill" style={{ backgroundColor: "#9e6de0", borderColor: "#9e6de0" }} onClick={handleConfirm}>Confirm</button>
						</div>
					</div>
				</div>
			)}

			{showResultModal && resultDetails && (
				<div className="modal-backdrop" style={{
					position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
					background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
				}}>
					<div style={{
						background: "#fff", borderRadius: 12, width: "90%", maxWidth: 420, overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,0.25)"
					}}>
						{/* Modal Header using Brand Purple */}
						<div style={{
							background: resultDetails.success ? "linear-gradient(135deg, #9e6de0 0%, #8243d7 100%)" : "linear-gradient(135deg, #dc3545 0%, #bd2130 100%)",
							padding: "18px 20px", color: "#fff", textAlign: "center"
						}}>
							<h5 style={{ color: "#fff", margin: 0, fontWeight: "bold", fontSize: "1.2rem" }}>
								{resultDetails.success ? "PAN Retrieved Successfully" : "PAN Search Unsuccessful"}
							</h5>
						</div>

						<div style={{ padding: 24, textAlign: "center" }}>
							{resultDetails.success ? (
								<>
									<div style={{ textAlign: "left", background: "#f8f9fa", padding: 16, borderRadius: 8, border: "1px solid #e9ecef", marginBottom: 20 }}>
										<p style={{ margin: "6px 0", color: "#495057" }}><strong>Applicant Name:</strong> {formData.name}</p>
										<p style={{ margin: "6px 0", color: "#495057" }}><strong>Aadhaar No:</strong> {formData.aadhaarNo}</p>
										<div style={{ margin: "12px 0 6px 0", borderTop: "1px dashed #dee2e6", paddingTop: 10 }}>
											<strong style={{ color: "#212529" }}>PAN Number:</strong> 
											<div style={{
												marginTop: 6,
												background: "#e8f5e9",
												color: "#2e7d32",
												padding: "10px 14px",
												borderRadius: 6,
												fontWeight: "bold",
												fontSize: "1.35rem",
												letterSpacing: "2px",
												textAlign: "center",
												border: "1px solid #a5d6a7"
											}}>
												{resultDetails.panNumber}
											</div>
										</div>
									</div>
									<p style={{ fontSize: "88%", color: "#6c757d", marginBottom: 20 }}>₹45 has been deducted from your wallet balance.</p>
									<button className="btn btn-primary btn-block btn-pill" style={{ backgroundColor: "#9e6de0", borderColor: "#9e6de0" }} onClick={() => {
										setShowResultModal(false);
										navigate("/dashboard/pan-find-report");
									}}>Go to Reports</button>
								</>
							) : (
								<>
									<div style={{ textAlign: "left", background: "#fff5f5", border: "1px solid #ffcdd2", padding: 16, borderRadius: 8, marginBottom: 20, color: "#721c24" }}>
										<p style={{ margin: "6px 0" }}><strong>Applicant Name:</strong> {formData.name}</p>
										<p style={{ margin: "6px 0" }}><strong>Aadhaar No:</strong> {formData.aadhaarNo}</p>
										<p style={{ margin: "6px 0" }}><strong>Date of Birth:</strong> {formData.dateOfBirth ? new Date(formData.dateOfBirth).toLocaleDateString("en-GB") : ""}</p>
										<p style={{ margin: "10px 0 0 0", borderTop: "1px solid #ffcdd2", paddingTop: 10, color: "#c62828" }}>
											<strong>Reason:</strong> {resultDetails.message}
										</p>
									</div>
									<p style={{ fontSize: "88%", color: "#6c757d", marginBottom: 20 }}>₹45 has been deducted from your wallet balance for this search attempt.</p>
									<button className="btn btn-primary btn-block btn-pill" style={{ backgroundColor: "#9e6de0", borderColor: "#9e6de0" }} onClick={() => {
										setShowResultModal(false);
										navigate("/dashboard/pan-find-report");
									}}>Go to Reports</button>
								</>
							)}
						</div>
					</div>
				</div>
			)}


		</div>

	);
};
export default PanFind;